import React, { useState, useEffect, useMemo } from 'react';
import { useCollect } from 'hooks';

import Show from 'components/Show';
import Modal from 'components/Modal';
import Action from 'components/Misc/Action';
import Nothing from 'components/Misc/Nothing';
import Progress from 'components/Misc/Progress';
import { Button } from 'components/Misc/Form';

import Blank from 'containers/Administrator/Users/Profile/Student/Grades/Blanks/Blank';

const Blanks = ({ visible, gradeId }) => {
	// Store modal's visibility
	const [modal, setModal] = useState(false);

	// Store request parameters
	const parameters = useMemo(() => ({
		eager: '[courses.[subject, exam]]',
		gradeId
	}), [gradeId]);

	// Store collected blanks
	const [[blanks, progress], collect] = useCollect('blanks', parameters);

	// Collect subjects on mount
	useEffect(() => {
		if (modal) (async () => await collect())();
	}, [modal, collect]);

	// Toggle modal's visibility
	const handleModal = () => setModal(m => !m);

	// Do not show blank's if some courses are selected
	if (!visible) return null;

	return (
		<>
			{/* Student's blank modal toggle */}
			<Action
				icon="folder_special"
				title="Pievienot sagatavi"
				subtitle="Piesaistiet vairākus kursus izvēloties sagatavi"
				onClick={handleModal}
			/>

			{/* Student's blank selection modal */}
			<Modal title="Pievienot sagatavi" visible={modal} handleModal={handleModal}>
				<div className="space-y-4">
					{/* List blanks for selection */}
					<Show if={blanks?.length && !progress}>
						<div className="grid md:grid-cols-2 gap-4">
							{blanks?.map(blank =>
								<Blank key={blank.id} blank={blank} gradeId={gradeId} handleModal={handleModal} />
							)}
						</div>
					</Show>

					{/* Show loading progress */}
					<Progress progress={progress} />
			
					{/* Show nothing */}
					<Nothing visible={!blanks?.length && !progress} />

					{/* Modal's controls */}
					<div className="flex justify-end">
						<Button
							icon="check"
							theme="success"
							value="Saglabāt"
							onClick={handleModal}
						/>
					</div>
				</div>
			</Modal>
		</>
	);
};

export default Blanks;